export class CartPriceComponents {
    _fields = ['price', 'checking'];

    price = 0;
    checking = 0;

    total() {
        let total = 0;
        for(let i = 0; i < this._fields.length; i++) {
            total += this[this._fields[i]];
        }
        return total;
    }

    /**
     * Add given components to the current instance
     * @param {CartPriceComponents} components
     * @param {number} count
     */
    add(components, count = 1) {
        for(let i = 0; i < this._fields.length; i++) {
            const field = this._fields[i];
            this[field] += components[field] * count;
        }
    }

    /**
     *
     * @param {number} count
     * @returns {string}
     */
    priceFormatted(count = 1) {
        return this._format(this.price * count);
    }

    /**
     *
     * @param {number} count
     * @returns {string}
     */
    checkingFormatted(count = 1) {
        return this._format(this.checking * count);
    }

    /**
     *
     * @param {number} count
     * @returns {string}
     */
    totalFormatted(count = 1) {
        return this._format(this.total() * count);
    }

    _format(value) {
        const formatted = value.toFixed(2);
        return formatted > 0 ? formatted : '0';
    }
}


// WEBPACK FOOTER //
// ./modules/packages/common/model/cartpricecomponents.js